var common = require("../../../utiles/common.js");
var imgGet = require("./switchImg.js");

module.exports = {
    register: function () {
        document.createElement('tab-login')
        ko.components.register('tab-login', {
            viewModel: function (params) {
                var $this = this;
                common.refreshNode();//刷新node
                $this.loginTemplate = localStorage.getItem("loginTemplate") == undefined?"default":localStorage.getItem("loginTemplate");
            },
            template: require("./TabLogin.html")
        });
        document.createElement('default-login')
        ko.components.register('default-login', {
            viewModel: function (params) {
                var $this = this;
                $this.img = imgGet.random(1,10);
            },
            template: require("../template/DefaultLogin.html")
        });
        document.createElement('concise-login')
        ko.components.register('concise-login', {
            viewModel: function (params) {
                var $this = this;

            },
            template: require("../conciseTemplate/ConciseLogin.html")
        });
        document.createElement('small-concise-login')
        ko.components.register('small-concise-login', {
            viewModel: function (params) {
                var $this = this;

            },
            template: require("../smallConcise/SmallConcise.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/login/tabLogin/TabLogin.js
// module id = 107
// module chunks = 0